export const EXTERNAL = 'EXTERNAL';
export const INTERNAL = 'INTERNAL';

export const METHODS_MAP = {
  kycaid: EXTERNAL,
  manual: INTERNAL
};
